import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Admin.css";
import axios from "axios";

const KebunP = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [rencanaTanam, setRencanaTanam] = useState(0);
  const [rencanaPanen, setRencanaPanen] = useState(0);

  // State untuk Data Petani
  const [petaniList, setPetaniList] = useState([]);
  const [loadingPetani, setLoadingPetani] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Fetch Info User
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => console.error("Error fetching user info:", error));

    // Fetch Rencana Tanam & Panen
    const fetchRencanaData = async () => {
      try {
        const responseTanam = await axios.get(
          "https://c-greenproject.org:7500/view_rencana_tanam"
        );
        setRencanaTanam(
          responseTanam.data.tanams ? responseTanam.data.tanams.length : 0
        );

        const responsePanen = await axios.get(
          "https://c-greenproject.org:7500/view_panen"
        );
        setRencanaPanen(
          responsePanen.data.panens ? responsePanen.data.panens.length : 0
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Fetch Daftar Petani
    const fetchPetani = async () => {
      setLoadingPetani(true);
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/petani",
          { withCredentials: true }
        );
        if (response.data.success) {
          setPetaniList(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching petani list:", error);
      } finally {
        setLoadingPetani(false);
      }
    };

    fetchRencanaData();
    fetchPetani();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  // Filter Pencarian Petani
  const filteredPetani = useMemo(() => {
    if (!searchTerm.trim()) return petaniList;
    const term = searchTerm.toLowerCase();
    return petaniList.filter(
      (item) =>
        (item.nama && item.nama.toLowerCase().includes(term)) ||
        (item.nomor_hp && item.nomor_hp.toLowerCase().includes(term))
    );
  }, [petaniList, searchTerm]);

  // Kalkulasi Pagination
  const totalPages = Math.ceil(filteredPetani.length / itemsPerPage) || 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPetani = filteredPetani.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      {/* Header */}
      <div className="header d-flex justify-content-between align-items-center px-4 py-2 bg-white border-bottom shadow-sm">
        <img src="/static/logo_potrait.png" alt="Logo" style={{ height: "40px" }} />
        <div className="d-flex align-items-center gap-3">
          <span className="fw-semibold text-secondary">{userInfo.full_name}</span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white border-end" style={{ width: "240px", flexShrink: 0 }}>
          <p className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 className="fw-bold mb-2">Telsa Super Apps</h6>
          <p className="text-muted small d-flex align-items-center gap-2 mb-4">
            <img src="/static/schedule_11145854.png" alt="Date" width="16" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush gap-1">
            <div
              onClick={() => navigate("/kebun")}
              className={`list-group-item rounded-3 border-0 py-2.5 ${
                location.pathname === "/kebun" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" width="18" className="me-2" /> Beranda
            </div>
            <div
              onClick={() => navigate("/KebunP")}
              className={`list-group-item rounded-3 border-0 py-2.5 ${
                location.pathname.toLowerCase().includes("kebunp") &&
                !location.pathname.toLowerCase().includes("kebunpabrik")
                  ? "bg-success text-white fw-bold"
                  : "text-dark"
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" width="18" className="me-2" /> Petani
            </div>
            <div
              onClick={() => navigate("/kebunL")}
              className={`list-group-item rounded-3 border-0 py-2.5 ${
                location.pathname.toLowerCase().includes("kebunl")
                  ? "bg-success text-white fw-bold"
                  : "text-dark"
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/shipping.png" alt="Logistics" width="18" className="me-2" /> Logistik
            </div>
            <div
              onClick={() => navigate("/kebunpabrik")}
              className={`list-group-item rounded-3 border-0 py-2.5 ${
                location.pathname === "/kebunpabrik" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/factory.png" alt="Factory" width="18" className="me-2" /> Pabrik
            </div>
          </div>
        </div>

        {/* Main Content Container */}
        <div className="flex-grow-1 p-4" style={{ width: "calc(100% - 240px)" }}>
          <div className="mb-4">
            <h2 className="fw-bold text-dark mb-1">Mitra Petani</h2>
            <p className="text-muted small mb-0">
              Kelola data petani mitra terdaftar, pantau rencana tanam, serta estimasi panen berjalan.
            </p>
          </div>

          {/* Metric Cards - Diset Flex teratur dan responsif */}
          <div className="d-flex flex-wrap gap-3 mb-4 w-100">
            {/* Card Tanam */}
            <div
              onClick={() => navigate("/kebunprt")}
              className="bg-white p-3 rounded-4 shadow-sm border d-flex align-items-center justify-content-between flex-grow-1"
              style={{ cursor: "pointer", minWidth: "280px" }}
            >
              <div>
                <span className="text-muted small fw-bold d-block">RENCANA TANAM</span>
                <h2 className="fw-bold text-danger my-1">{rencanaTanam.toLocaleString("id-ID")}</h2>
                <span className="text-muted small">Lihat detail plot tanam →</span>
              </div>
              <div
                className="rounded-3 bg-danger-subtle d-flex align-items-center justify-content-center"
                style={{ width: "52px", height: "52px" }}
              >
                <img src="/static/Tanam.png" alt="Rencana Tanam" width="30" height="30" />
              </div>
            </div>

            {/* Card Panen */}
            <div
              onClick={() => navigate("/kebunPRP")}
              className="bg-white p-3 rounded-4 shadow-sm border d-flex align-items-center justify-content-between flex-grow-1"
              style={{ cursor: "pointer", minWidth: "280px" }}
            >
              <div>
                <span className="text-muted small fw-bold d-block">RENCANA PANEN</span>
                <h2 className="fw-bold text-success my-1">{rencanaPanen.toLocaleString("id-ID")}</h2>
                <span className="text-muted small">Lihat jadwal panen →</span>
              </div>
              <div
                className="rounded-3 bg-success-subtle d-flex align-items-center justify-content-center"
                style={{ width: "52px", height: "52px" }}
              >
                <img src="/static/schedule_11145854.png" alt="Rencana Panen" width="30" height="30" />
              </div>
            </div>
          </div>

          {/* Tabel Container */}
          <div className="bg-white rounded-4 shadow-sm border overflow-hidden w-100">
            {/* Header Card & Search */}
            <div className="p-3 border-bottom d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div>
                <h5 className="fw-bold text-dark mb-0">Daftar Petani Terdaftar</h5>
                <span className="text-muted small">
                  Total {filteredPetani.length} petani aktif dalam sistem
                </span>
              </div>
              <div style={{ width: "260px" }}>
                <input
                  type="text"
                  className="form-control form-control-sm rounded-pill px-3"
                  placeholder="Cari nama / nomor HP..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>

            {/* Header List */}
            <div className="d-flex bg-light py-2 px-4 text-secondary small fw-bold border-bottom">
              <div style={{ width: "60px" }}>#</div>
              <div className="flex-grow-1">NAMA PETANI</div>
              <div style={{ width: "200px" }}>NOMOR HP</div>
              <div style={{ width: "160px" }} className="text-end">TOTAL LUAS LAHAN</div>
            </div>

            {/* List Data */}
            <div className="w-100">
              {loadingPetani ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-success spinner-border-sm" role="status"></div>
                  <p className="text-muted mt-2 small">Memuat data petani...</p>
                </div>
              ) : filteredPetani.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <span className="fs-2">🌾</span>
                  <p className="mt-2 mb-0 small">Tidak ada data petani ditemukan.</p>
                </div>
              ) : (
                currentPetani.map((petani, index) => (
                  <div
                    key={petani.id || index}
                    className="d-flex align-items-center py-3 px-4 border-bottom bg-white"
                  >
                    <div className="text-muted small" style={{ width: "60px" }}>
                      {indexOfFirstItem + index + 1}
                    </div>
                    <div className="flex-grow-1 d-flex align-items-center gap-3">
                      <div
                        className="rounded-circle bg-success-subtle text-success d-flex align-items-center justify-content-center fw-bold small flex-shrink-0"
                        style={{ width: "34px", height: "34px" }}
                      >
                        👨‍🌾
                      </div>
                      <span className="fw-semibold text-dark">{petani.nama}</span>
                    </div>
                    <div className="text-muted small" style={{ width: "200px" }}>
                      📞 {petani.nomor_hp || "-"}
                    </div>
                    <div className="text-end fw-semibold text-success" style={{ width: "160px" }}>
                      {petani.total_luas_lahan_aktif ?? 0} Ha
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Pagination Footer */}
            {!loadingPetani && filteredPetani.length > 0 && (
              <div className="p-3 bg-white border-top d-flex flex-wrap justify-content-between align-items-center gap-2">
                <span className="text-muted small">
                  Menampilkan <b>{indexOfFirstItem + 1}</b> -{" "}
                  <b>{Math.min(indexOfLastItem, filteredPetani.length)}</b> dari{" "}
                  <b>{filteredPetani.length}</b> data
                </span>

                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                      ‹
                    </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(
                      (p) =>
                        p === 1 ||
                        p === totalPages ||
                        (p >= currentPage - 1 && p <= currentPage + 1)
                    )
                    .map((p, idx, arr) => (
                      <React.Fragment key={p}>
                        {arr[idx - 1] && p - arr[idx - 1] > 1 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}
                        <li className={`page-item ${currentPage === p ? "active" : ""}`}>
                          <button className="page-link" onClick={() => handlePageChange(p)}>
                            {p}
                          </button>
                        </li>
                      </React.Fragment>
                    ))}
                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                      ›
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KebunP;